import CryptoJS from 'crypto-js';

export const decryptDataForVc = (encryptedData) =>
{
	try
	{
		const bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedData), import.meta.env.VITE_AUTH_KEY);
		const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

		return decryptedData;
	}
	catch (error)
	{
		return '';
	}
};